import { useGetUserById } from '@/services/users/useUser';
import { IGetUserByIdApiField, IUseGetUserById } from '@/services/users/types';
import { getCurrentUuid } from '@/utils/helpers/authHelpers';

/** Stable fields for current-user GET /users/{userUuid} so all callers share one query key. */
export const CURRENT_USER_BY_ID_FIELDS: IGetUserByIdApiField[] = [
  'email',
  'phone',
  'countryCode',
  'organization',
  'license',
];

export interface IUseGetCurrentUser {
  queryConfig?: IUseGetUserById['queryConfig'];
}

const useGetCurrentUser = ({
  queryConfig = {},
}: IUseGetCurrentUser = {}) => {
  const userUuid = getCurrentUuid();
  return useGetUserById({
    userUuid,
    fields: CURRENT_USER_BY_ID_FIELDS,
    queryConfig: {
      enabled: !!userUuid,
      ...queryConfig,
    },
  });
};

export { useGetCurrentUser };
